export default __webpack_public_path__ + "static/media/3334 spice rack F side.2c697f35.png";